/**
 * The locale a URL is served under, or undefined when the path carries no prefix.
 *
 * Sites that build one page per language put the locale first in the path
 * (`/en/`, `/es/`) — see node-utils/localisedRoutes.js, which is what creates those
 * URLs. This is the runtime counterpart: given a path, say which language the reader
 * is actually looking at, so analytics can report it without anybody parsing URLs in
 * a dashboard.
 *
 * Returns undefined rather than a default for an unprefixed path. Those exist only
 * until the nginx redirect sends the visitor to a prefixed URL, and reporting a
 * language we did not serve would be worse than reporting none.
 */
export const URL_LOCALE_PREFIXES = ['en', 'es']

export const languageFromPath = pathname => {
  const first = String(pathname || '').split('/')[1]
  return URL_LOCALE_PREFIXES.includes(first) ? first : undefined
}
